/**
 * Whether the menu offers the Wins row. Shown only once a read has found at least one win.
 *
 * - loading, nothing read yet → hidden, so a reader with no wins never sees the row flash in.
 * - failed read with nothing read before → hidden. Showing it offered a page that could only say
 *   "Couldn't load your wins", and made the menu change shape whenever the network dropped (QA,
 *   Oct 21). Wins already read stay through a failed refresh, so a reader who has wins keeps the row.
 * - no wins → hidden. The `/wins` route and its deep link still work and still draw the empty state.
 *
 * Shared 1:1 with iOS `WinsNav.showsRow` and Android `winsNavShowsRow`.
 */
export function winsNavRowVisible(read: { count: number }): boolean {
  return read.count > 0;
}
